module.exports = __webpack_public_path__ + "media/guide.048d3b98.mp4";